'use strict';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import { sync } from 'vuex-router-sync';
import './boostrap';
import locales from './locales';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import BasicLayout from './layouts/SimpleLayout.vue';
import AppLayout from './layouts/AppLayout.vue';
import Confirm from './components/Confirm.vue';
import Notifications from 'vue-notification';
import VuetifyDaterangePicker from 'vuetify-daterange-picker';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.use(VuetifyDaterangePicker);

Vue.component('basic-layout', BasicLayout);
Vue.component('app-layout', AppLayout);
Vue.component('Confirm', Confirm);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.use(Notifications);

const configVeeValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messsages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false,
};
Vue.use(VeeValidate, configVeeValidate);
Vue.use(VueI18n);

// Vue.prototype.$toast = toast;

// window.localStorage.getItem('language')
const lang = 'en';

const i18n = new VueI18n({
  locale: lang,
  messages: locales,
});

window._ = require('lodash');

window.router = router;

sync(store, router);

Vue.config.productionTip = false;

store.dispatch('auth/check');
store.dispatch('layout/check');
// store.dispatch('l/check');

window.Vue = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

store.dispatch('lang/change', lang);
